import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  map: {
    width: '100%',
    height: '100%',
  },
  header: {
    color: theme.palette.textcolor.main,
    textTransform: 'uppercase',
    fontSize: '1.4375em',
    fontStyle: 'italic',
    marginBottom: 10,
  },
  text: {
    color: '#000000',
    display: 'block',
    maxWidth: 700,
    marginBottom: 20,
  },
}));

export default useStyles;
